// ----------------------------------------------------------------------
const accountData = JSON.parse(localStorage.getItem('profile'));
const account = {
  displayName: accountData? accountData.fullname :"Full Name",
  email: accountData? accountData.email :"Email",
  photoURL:  'https://www.w3schools.com/howto/img_avatar.png',
};

export default account;